<template>
  <div class="app-root">
    <template v-if="$route.meta.bare || $route.meta.immersive">
      <RouterView />
    </template>
    <template v-else>
      <button v-if="mobileNavOpen" class="mobile-nav-backdrop" aria-label="关闭导航" @click="mobileNavOpen = false"></button>
      <AppSidebar :collapsed="sidebarCollapsed" :mobile-open="mobileNavOpen" @toggle="toggleSidebar" @navigate="mobileNavOpen = false" />
      <main class="app-main" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
        <AppHeader @menu="mobileNavOpen = true" />
        <RouterView v-slot="{ Component }">
          <Transition name="page" mode="out-in">
            <component :is="Component" />
          </Transition>
        </RouterView>
      </main>
    </template>
  </div>
</template>

<script setup>
import { ref } from "vue";
import AppSidebar from "./components/AppSidebar.vue";
import AppHeader from "./components/AppHeader.vue";

const sidebarCollapsed = ref(false);
const mobileNavOpen = ref(false);

function toggleSidebar() {
  if (window.matchMedia("(max-width: 760px)").matches) {
    mobileNavOpen.value = false;
    return;
  }
  sidebarCollapsed.value = !sidebarCollapsed.value;
}
</script>
